import { jsx as e } from "react/jsx-runtime";
import { Button as h, Link as p } from "@chakra-ui/react";
import { ThemeColorVariable as l, ThemeSpaceVariable as c, ThemeFontSizeVariable as f, ThemeFontVariable as s } from "../../theme/theme-types.js";
const d = {
  fontFamily: s.Body,
  fontSize: f.Medium,
  color: l.OnSurface,
  py: c.Small,
  px: c.Medium,
  fontWeight: "medium",
  // "Reset" styles:
  textDecoration: "none",
  userSelect: "none",
  height: "auto",
  borderRadius: 0,
  textAlign: "left",
  background: "transparent",
  outline: "none",
  lineHeight: "auto",
  border: 0,
  // Pseudo styles:
  _disabled: {
    opacity: 0.48
  },
  _hover: {
    bg: l.AccentHoverAlpha,
    cursor: "pointer",
    _disabled: { bg: "none", cursor: "not-allowed" }
  },
  _active: {
    bg: l.AccentActiveAlpha
  }
};
function A({
  children: o,
  display: t = "block",
  w: i = "100%",
  minW: n = "auto",
  minH: r = "auto",
  to: a = void 0,
  href: m = void 0,
  isDisabled: u,
  ...b
}) {
  return /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(
    p,
    {
      sx: d,
      w: i,
      minW: n,
      minH: r,
      display: t,
      to: a,
      href: u ? void 0 : m,
      "aria-disabled": u,
      ...b,
      children: o
    }
  ) });
}
function S({
  children: o,
  display: t = "block",
  w: i = "100%",
  minW: n = "auto",
  minH: r = "auto",
  ...a
}) {
  return /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(h, { sx: d, w: i, minW: n, minH: r, display: t, type: "button", ...a, children: o }) });
}
export {
  S as NavigationListButton,
  A as NavigationListLink
};
